import { X, Mail } from 'lucide-react';
import { Drawer, DrawerContent, DrawerTitle, DrawerClose } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import i18n from '@/lib/i18n';

function getFaqItems() {
    return [
        {
            question: i18n.t('welcome:commentFonctionneHorodaty'),
            answer: i18n.t('welcome:horodatyCertifieVosPhotosAvecLaDateL'),
        },
        {
            question: i18n.t('welcome:mesPhotosSontEllesSecurisees'),
            answer: i18n.t('welcome:ouiToutesVosPhotosSontCrypteesEtStockees'),
        },
    ];
}

export function HelpDrawer({ open, onOpenChange }) {
    const { t } = useTranslation();
    const faqItems = getFaqItems();
    return (
        <Drawer open={open} onOpenChange={onOpenChange}>
            <DrawerContent className="max-h-[90vh] rounded-t-[20px]">
                {/* Header */}
                <div className="flex items-center justify-between p-5 border-b border-border shrink-0">
                    <DrawerTitle className="font-semibold text-lg text-foreground">{t('welcome:besoinDAide')}</DrawerTitle>
                    <DrawerClose asChild>
                        <Button
                            variant="plain"
                            color="neutral"
                            size="auto"
                            className="h-8 w-8 rounded-full bg-surface hover:bg-border transition-colors"
                        >
                            <X className="h-5 w-5 text-foreground" />
                        </Button>
                    </DrawerClose>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-5">
                    <div className="space-y-5">
                        {/* Contact section */}
                        <div className="bg-surface rounded-2xl p-5">
                            <div className="flex items-center gap-3 mb-3">
                                <Mail className="h-5 w-5 text-muted-foreground" />
                                <h3 className="font-semibold text-base text-foreground">{t('welcome:contactezNous')}</h3>
                            </div>
                            <p className="text-sm text-muted-foreground mb-2">
                                {t('welcome:uneQuestionNotreEquipeEstLaPourVous')}
                            </p>
                            <a
                                href="mailto:support@horodaty.com"
                                className="text-sm text-primary font-medium hover:underline"
                            >
                                support@horodaty.com
                            </a>
                        </div>

                        {/* FAQ section */}
                        <div>
                            <h3 className="font-semibold text-base text-foreground mb-3">{t('welcome:questionsFrequentes')}</h3>
                            <div className="space-y-3">
                                {faqItems.map((item, index) => (
                                    <div key={index} className="bg-surface rounded-xl p-4">
                                        <p className="font-semibold text-sm text-foreground mb-2">{item.question}</p>
                                        <p className="text-[13px] text-muted-foreground">{item.answer}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </DrawerContent>
        </Drawer>
    );
}
